import { Delta } from "@vueup/vue-quill";
import {
  SelfAssessmentStep,
  WordSelectionMode,
} from "~/classes/models/self-assessment/self-assessment-step.model";
import { useAttributeInstances } from "./quill-selection/useAttributeInstances";
import { useCountWords } from "./quill-selection/useCountWords";

const applySentenceMarkerInstances = ({
  documentId,
  step,
  editorRef,
  quillDelta,
}: {
  editorRef: any | undefined;
  quillDelta: Delta;
  documentId: string;
  step: SelfAssessmentStep;
}) => {
  var marker = step.sentenceOpenerMarkerValidation;
  var attribute = step.criteriaAttribute.attribute;

  const documentSelfAssessmentStore =
    useDocumentSelfAssessmentStore(documentId);
  const {
    stepCriteriaAttributes,
    activeStep,
    allParagraphs,
    allSteps,
    allSentences,
    bodyParagraphs,
  } = storeToRefs(documentSelfAssessmentStore);

  if (marker == undefined) {
    return;
  }

  if (attribute == undefined) {
    return;
  }

  const sentences = allSentences.value;

  const sentencesWithMarker = sentences.filter((sentence: any) => {
    return sentence.text.includes(marker ?? "");
  });

  var quill = editorRef?.getQuill?.();
  if (quill == undefined) {
    return;
  }

  for (const sentence of sentencesWithMarker) {
    const instanceId = useGenerateUID();
    quill.formatText(sentence.start, sentence.length, attribute, instanceId);
  }
};
const applyFormattingInstances = ({
  documentId,
  step,
  editorRef,
  quillDelta,
}: {
  documentId: string;
  editorRef: any | undefined;
  quillDelta: Delta;
  step: SelfAssessmentStep;
}) => {
  var validationAttributes = step.validationAttributes;
  if (validationAttributes == undefined) {
    return;
  }

  const documentSelfAssessmentStore =
    useDocumentSelfAssessmentStore(documentId);
  const paragraphPositions =
    documentSelfAssessmentStore.stepParagraphPositions(step);

  const bodyParagraphs = documentSelfAssessmentStore.bodyParagraphs;

  const relevantBodyParagraphs = [] as { index: number; data: any }[];

  for (const position of paragraphPositions) {
    const index = position - 1;
    const paragraph = bodyParagraphs[index];
    relevantBodyParagraphs.push(paragraph);
  }

  for (const [attribute, value] of Object.entries(validationAttributes)) {
    if (
      attribute == "bold" ||
      attribute == "background" ||
      attribute == "italic"
    ) {
      const instances = useAttributeInstances(
        editorRef?.getQuill?.(),
        quillDelta.ops,
        attribute
      );

      var quill = editorRef?.getQuill?.();

      if (quill == undefined) {
        return;
      }

      const relevantInstances = instances.filter((instance) => {
        if (attribute == "background" && instance.value == "transparent") {
          return false;
        }

        return relevantBodyParagraphs.some((paragraph) => {
          return paragraph.index == instance.paragraphIndex;
        });
      });

      console.log(relevantInstances);

      for (const instance of relevantInstances) {
        const wordCount = useCountWords(instance.textSnippet ?? "");
        if (
          wordCount > 1 &&
          step.wordSelectionMode == WordSelectionMode.autoSplit
        ) {
          const textSnippet = instance.textSnippet ?? "";
          const matches = textSnippet.matchAll(/\S+/g);

          let newInstanceIds = [];

          // Now we need to apply the attribute to each word as a sub range of the original instance.
          for (const match of matches) {
            const word = match[0];
            const wordOffset = match.index;

            if (wordOffset !== undefined) {
              const newInstanceId = useGenerateUID();
              quill.formatText(
                instance.start + wordOffset,
                word.length,
                step.criteriaAttribute.attribute,
                newInstanceId
              );
              newInstanceIds.push(newInstanceId);
            }
          }
        } else {
          const textSnippet = instance.textSnippet ?? "";
          const trimmedText = textSnippet.trim();

          if (trimmedText.length === 0) {
            continue;
          }

          const startIndex = textSnippet.indexOf(trimmedText);

          var instanceId = useGenerateUID();

          quill.formatText(
            instance.start + startIndex,
            trimmedText.length,
            step.criteriaAttribute.attribute,
            instanceId
          );
        }
      }
    }
  }
};

export const useAutoApplyInstances = ({
  documentId,
  step,
  editorRef,
  quillDelta,
}: {
  documentId: string;
  step: SelfAssessmentStep;
  editorRef: any | undefined;
  quillDelta: Delta;
}) => {
  if (step.autoApplyInstances != true) {
    return;
  }

  if (step.sentenceOpenerMarkerValidation != undefined) {
    applySentenceMarkerInstances({
      documentId,
      step,
      editorRef,
      quillDelta,
    });
  }

  if (
    step.validationAttributes != undefined &&
    Object.keys(step.validationAttributes).length > 0
  ) {
    applyFormattingInstances({
      documentId,
      step,
      editorRef,
      quillDelta,
    });
  }
};
